import { BakedInConfig, BakedInAdvancedOptions } from 'utils/models';

// Pulled out of MonetisationModal.tsx so these pure checks can be unit
// tested without importing that file's full service/slice module graph.
export const isJingleMethodEnabled = (
  advanced: BakedInAdvancedOptions,
): boolean => advanced.detectionMethods.jingle.isEnabled;

export const hasAnyDetectionMethodEnabled = (
  advanced: BakedInAdvancedOptions,
): boolean =>
  Object.values(advanced.detectionMethods).some((item) => item.isEnabled);

// Builds the bakedInConfig actually sent to the save API. jingleIdentification
// (CAP-12) always mirrors the advanced jingle method's isEnabled here — never
// whatever the legacy switcher was last set to — so this exact wiring has a
// regression test independent of MonetisationModal.tsx being importable under
// Jest (see the pre-existing, unrelated getLocalStorageFilter failure noted
// in this spec's Implementation Notes).
export const buildBakedInConfigForSave = (
  bakedInConfig: BakedInConfig,
): BakedInConfig => ({
  ...bakedInConfig,
  jingleIdentification: isJingleMethodEnabled(bakedInConfig.advanced),
});
